module.exports = __webpack_public_path__ + "img/chat-person-2.6173b01.png";